export const GET_GENERAL_DATA_REQUEST = 'GET_GENERAL_DATA_REQUEST';
export const GET_GENERAL_DATA_SUCCESS = 'GET_GENERAL_DATA_SUCCESS';
export const GET_GENERAL_DATA_FAILD = 'GET_GENERAL_DATA_FAILD';
export const SET_INITILIZED_DATA = "SET_INITILIZED_DATA";
export const GET_CATEGORIES_COURSE = "GET_CATEGORIES_COURSE";
export const GET_CATEGORIES_COURSE_SUCCESS = "GET_CATEGORIES_COURSE_SUCCESS";
